import { SearchAndFilterTypes } from "src/constants";
import { ButtonFilter, CommonFilterProps, FormFilter } from "../CommonFilters";

// Single toggle: when on, sends ineligibleSchoolChoice=true, returning forms
// where staff overrode eligibility on a school choice (is_override = true).
const OPTIONS = [{ label: "Ineligible school choice", id: "true" }];

export const IneligibleSchoolChoiceFilter = (props: CommonFilterProps) => {
  return (
    <FormFilter label="School selection override">
      <ButtonFilter
        filterKey={SearchAndFilterTypes.IneligibleSchoolChoice}
        options={OPTIONS}
        {...props}
      />
    </FormFilter>
  );
};
